import './Report.css';
import config from "../config.json";
import {
    Button,
    Dropdown,
    Modal,
} from 'react-bootstrap';
import './EditDevice.css'
import AsyncSelect from 'react-select/async';
//import Select, { ActionMeta, OnChangeValue, Options, components, ControlProps, OptionProps, Props, StylesConfig } from 'react-select'
import { components } from 'react-select'

import React, { useContext, useEffect, useState, useRef } from "react";
import profileEdit from '../Images/contact.jpg'
import edit from '../Images/edit.png'
import ConfirmDialog from './ConfirmDialog'
//import DatePicker from 'react-datepicker2';
//import { MainContext } from "../store/mainContext";

import { Link } from 'react-router-dom';
import http from "../Services/httpService";
//import moment from 'moment-jalaali'
//import momentJalaali from 'moment-jalaali';
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function EditDevice({ show, handleClose, device }) {
    const [showIng, setShowIng] = useState(false);
    const [form, setForm] = useState({});
    const [isPosting, setIsPosting] = useState(false);
    const [previewImge, setPreviewImge] = useState(null);
    const picRef = useRef(null);

    const handleCloseIng = () => {
        setShowIng(false);
        handleClose(null);
    }

    useEffect(() => {
        setShowIng(show);
        setForm(device);
        setPreviewImge(`${config.apiUrl}/PicDriver/${device.id}.jpg?${new Date().getTime()}`);
        setCustomerChoice({ icon: device.icon })
    }, [show]);

    const handlePost = async (e) => {
        e.preventDefault();
        setIsPosting(true);
        await noronServices.UpdateDevice1({
            id: form.id,
            deviceName: form.deviceName,
            simNumber: form.simNumber,
            icon: form.icon,
            modeDevice: form.modeDeviceNumber,
            //fuelConsumption: form.fuelConsumption,
            //fuelTime: form.fuelTime,

            mobile: form.mobile,
            //nationalcode: form.nationalcode,
            pelak: form.pelak,
            file: form.file,
        })
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setShowIng(false);
                handleClose(form);
            })
            .catch(err => {
                setIsPosting(false);
            });
    }


    const upload = (e, background, name) => {
        const { files } = e.target;
        if (files.length === 0)
            return;
        if (background) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                //style={{ backgroundImage: `url(${travelDetailPic})` }}            
                background.current.style.backgroundImage = `url(${fileReader.result})`;
            };
            fileReader.readAsDataURL(files[0]);
        }
        setForm({ ...form, [name]: e.target.files[0] })
    }



    const [confirmDelete, setConfirmDelete] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const handleDelete = async (e) => {
        e.preventDefault();
        setIsDelete(true);
        setConfirmDelete(false)
        const response = await noronServices.DeleteDevice(form.id)
            .then(({ data }) => {
                setIsDelete(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                setShowIng(false);
                handleClose(form);
            })
            .catch(err => {
                setIsDelete(false);
            });
    }

    const [customerChoice, setCustomerChoice] = useState();
    const [typingTimeout, setTypingTimeout] = useState(setTimeout(() => { }, 3000));
    const loadOptions = (inputValue, callback) => {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        let temp = setTimeout(() => {
            noronServices.PicCarList(
                {
                    from: 0,
                    pageSize: 100,
                    filters: {
                        GroupOp: "",
                        Groups:
                            [{
                                groupOp: "and",
                                rules: inputValue == "" ? [] : [{ op: "cn", field: "name", data: `\"${inputValue}\"` },]
                            }]
                    }, where: ""
                    , order: ""
                }
                /*{
                from: 0,
                pageSize: 100,
                where: inputValue == "" ? "" : `name.Contains("${inputValue}")`,
                order: "",
            }
                */)
                .then(({ data }) => {
                    callback(data.payload.list.map((item, index) => {
                        return { index: index, value: item.name, ...item, icon: `car${item.id}.png` };
                        /*return {
                            index: index,
                            name: item.name,
                            value: item.name,
                            label2: item.name,
                            tel: item.tel,
                            mobile: item.mobile,
                            email: item.email,
                        }*/
                    }));
                })
                .catch(err => {
                });

        }, 700);
        setTypingTimeout(temp);
    }

    const formatOptionCustomerViewList = (data) => (
        <div className='row d-flex' style={{}}>
            <div className='col-auto '>
                <img src={`${config.apiUrl}/piccar/${data.icon != "" ? data.icon : "car1.png"}`} style={{ width: 40 }} />
            </div>
            <div className='col'>
                {data.name}
            </div>
        </div>
    );
    const Option = (props) => {
        return (
            <components.Option {...props} >
                <div className={`row rowOption`}>
                    <div className='col-auto'>
                        <img src={`${config.apiUrl}/piccar/car${props.data.id}.png`} className="picCar" />
                    </div>
                    <div className='col'>
                        {props.data.name}
                    </div>
                </div>
            </components.Option>
        );
    };

    const Control = ({ children, ...props }) => {
        return (
            <components.Control {...props}>
                {children}
            </components.Control>
        );
    };
    return (
        <>
            <ConfirmDialog show={confirmDelete}
                title={`آیا ردیاب ${form.deviceName} حذف شود؟`}
                handleDo={handleDelete}
                handleCancel={(e) => setConfirmDelete(false)}
                isBusy={false}
            />
            <Modal show={showIng} onHide={handleCloseIng} id="modalPatient" centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">
                        <Button variant="danger" className="col btn btn-danger  " data-bs-dismiss="modal"
                            onClick={(e) => setConfirmDelete(true)}
                            disabled={isDelete || isPosting}>
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                            <span>&nbsp;&nbsp;&nbsp;حذف دستگاه</span>
                        </Button>
                        تنظیمات دستگاه {form.deviceName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="form-floating mb-3">
                            <input asp-for="ime"
                                type="number"
                                name="ime"
                                value={form.ime}
                                onChange={e => http.handleChange(e, form, setForm)}
                                disabled={true}
                                className="form-control" placeholder="Ime" autoComplete="off" />
                            <label asp-for="ime">Ime</label>
                            <span asp-validation-for="ime" className="text-danger"></span>
                        </div>
                        <div className="form-floating mb-3">
                            <input asp-for="simNumber"
                                type="number"
                                name="simNumber"
                                value={form.simNumber}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="شماره سیم کارت درون ردیاب" autoComplete="off" />
                            <label asp-for="simNumber">شماره سیم کارت درون ردیاب</label>
                            <span asp-validation-for="simNumber" className="text-danger"></span>
                        </div>

                        <div className="form-floating mb-3">
                            <input asp-for="deviceName"
                                type="text"
                                name="deviceName"
                                value={form.deviceName}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="نام خودرو" autoComplete="off" />
                            <label asp-for="deviceName">نام خودرو</label>
                            <span asp-validation-for="deviceName" className="text-danger"></span>
                        </div>
                        {/*
                        <div className="form-floating mb-3">
                            <Dropdown drop="down"
                                onSelect={eventKey => {
                                    //console.log('eventKey', eventKey);
                                    setForm({
                                        ...form, icon: eventKey
                                    });
                                }}
                            >
                                <Dropdown.Toggle className="form-control" id="dropdown-custom-components">
                                    {form.icon != "" &&
                                        <img src={`/images/${form.icon}`} className="navbarIcon" />}آیکن خودرو
                                    {form.icon == "" && <>
                                        <img src="/images/car1.png" className="navbarIcon" />آیکن پیش فرض</>}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="form-control dropdownMenuCustom">
                                    {Array(24).fill().map((item, i) => (
                                        <Dropdown.Item key={"drop" + i + 1} eventKey={`car${i + 1}.png`}>
                                            <img src={`/images/car${i + 1}.png`} className="dropDownImageItem" />
                                        </Dropdown.Item>))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                                    */}
                        <AsyncSelect
                            className="  flex-fill mb-3"
                            styles={{
                                menu: provided => ({ ...provided, zIndex: 9999 }),
                                option: (provided, state) => {
                                    return {
                                        ...provided,
                                        // color: "blue",
                                        // backgroundColor: state.data === state.selectProps.value ? "red" : "white"
                                    };
                                }
                            }}
                            placeholder={'تصویر خودرو و انتخاب بفرمایید'}
                            //isLoading={isLoadingExternally}
                            value={customerChoice}
                            cacheOptions
                            loadOptions={loadOptions}
                            defaultOptions//={{id:1,name:"ddd"}}
                            formatOptionLabel={formatOptionCustomerViewList}
                            onChange={/*handleChangeSelect(newValue);*/
                                (newValue, actionMeta) => {
                                    setCustomerChoice(newValue);
                                    setForm({ ...form, icon: `car${newValue.id}.png` });
                                    console.log(newValue);
                                }
                            }
                            components={{
                                //   Control: Control,
                                Option: Option
                            }}
                        //isRtl
                        // isClearable                                                   
                        //isSearchable
                        //closeMenuOnSelect={false}
                        //closeMenuOnSelect={false}
                        //isMulti
                        //onInputChange={handleInputChange}
                        />

                        <div className="form-floating mb-3">
                            <select asp-for="modeDeviceNumber"
                                name="modeDeviceNumber"
                                value={form.modeDeviceNumber}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-select" placeholder="نوع ردیاب" autoComplete="off" >
                                <option value="0">S300</option>
                                <option value="3">S350</option>
                                <option value="1">S400</option>
                                <option value="2">S500</option>
                                <option value="4">S600</option>
                            </select>
                            <label asp-for="modeDeviceNumber">نوع ردیاب</label>
                            <span asp-validation-for="modeDeviceNumber" className="text-danger"></span>
                        </div>
                        {/*
                        <div className="form-floating mb-3">
                            <input asp-for="fuelConsumption"
                                type="number"
                                name="fuelConsumption"
                                value={form.fuelConsumption}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="میزان مصرف سوخت در 100 کیلومتر" autoComplete="off" />
                            <label asp-for="fuelConsumption">میزان مصرف سوخت در 100 کیلومتر</label>
                            <span asp-validation-for="fuelConsumption" className="text-danger"></span>
                        </div>
                       
                        <div className="form-floating mb-3">
                            <select
                                name="fuelTime"
                                value={form.fuelTime}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-select"
                                autoComplete="off" >
                                <option value="0">انتخاب کنید...</option>
                                <option value="4">سه سیلندر</option>
                                <option value="5">چهار سیلندر</option>
                                <option value="5.5">چهار سیلندر سوپر 4W</option>
                                <option value="6.5">شش سیلندر</option>
                                <option value="7.5">شش سیلندر 4W سوپر</option>
                            </select>
                            <label asp-for="fuelTime">میزان مصرف سوخت خودروهای سنگین</label>
                            <span asp-validation-for="fuelTime" className="text-danger"></span>
                        </div>
*/
                        }
                        <div className="form-floating mb-3">
                            <input asp-for="mobileDriver"
                                type="number"
                                name="mobile"
                                value={form.mobile}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="شماره تلفن راننده" autoComplete="off" />
                            <label asp-for="mobileDriver">شماره تلفن راننده</label>
                            <span asp-validation-for="mobileDriver" className="text-danger"></span>
                        </div>
                        {/*
                        <div className="form-floating mb-3">
                            <input asp-for="code"
                                type="number"
                                name="nationalcode"
                                value={form.nationalcode}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="کد ملی راننده" autoComplete="off" />
                            <label asp-for="code"> کد ملی راننده</label>
                            <span asp-validation-for="code" className="text-danger"></span>
                        </div>
                        */
                        }
                        <div className="form-floating mb-3">
                            <input asp-for="pelak"
                                type="text"
                                name="pelak"
                                value={form.pelak}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="شماره پلاک خودرو" autoComplete="off" />
                            <label asp-for="code"> شماره پلاک خودرو</label>
                            <span asp-validation-for="code" className="text-danger"></span>
                        </div>
                        <div className='row mb-2'>
                            <div className='col'>
                                <label asp-for="code">تصویر راننده</label>
                            </div>
                        </div>
                        <div className='row p-1 '>
                            <div className='col d-flex  align-items-center  justify-content-center '>
                                <div>
                                    <input
                                        type="file"
                                        className='d-none'
                                        ref={picRef}
                                        accept="image/*"
                                        onChange={(e) => {
                                            upload(e, null, "file");
                                            setPreviewImge(URL.createObjectURL(e.target.files[0]));
                                        }}
                                    />
                                    <img
                                        src={previewImge ? previewImge : profileEdit}
                                        className=''
                                        id="picProfile"
                                        onLoad={(e) => { console.log('e', e); }}
                                        onError={(e) => { console.log('error', e); setPreviewImge(null) }}
                                    />
                                    <Link to="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            picRef?.current?.click();
                                        }} >
                                        <img src={edit}
                                            className=''
                                            id="editPencil" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className="col btn btn-success btn-block myCustomButton"
                        onClick={handlePost}
                        disabled={isPosting}>
                        {isPosting &&
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                        <span>&nbsp;&nbsp;&nbsp;تایید </span>
                    </Button>
                    <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                        onClick={handleCloseIng}>
                        <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );

}
